export default __webpack_public_path__ + "static/media/Presentación Webinar Motores Euro 6_10_FINAL.ca890588.pdf";